(function (appComponents) {

	appComponents.services.cartBase = function (Components) {

		var cartBase = {
			get cartSize() {
				return cartBase._stash.cart.size;
			}
		};

		cartBase.name = "cartBase";
		cartBase.cartData = {};


		Components.getComponentPrototype().extend(cartBase);

		cartBase._modals = cartBase._getService("modals");
		cartBase._b2bUnit = cartBase._getService("b2bUnit");

		cartBase.elements = {
			get cartSizeWidget() {
				return $('[pc-container="cart--size-widget"]');
			},
			
			get cartSizeWidgetContainer() {
				return $(".cart-num").closest(".cart");
			}
		};

		cartBase.bindings = function () {
			// $(document).on("click", '[pc-container="cart--add-item"]', function () {
			// 	var productCode = $(this).parents('[pc-container="product-item"]').attr("pc-value");
			// 	cartBase.handlers.onAddItem(productCode);
			// });
		};


		cartBase.postAdditionFromQuote = function (res) {
			if (res) {
				if (res.status == 200 || res.status == 530 || res.status == 220) {
					cartBase._stash.cart.size = res.body.cartSize;
					cartBase.updateWidget();

					var succededProducts = res.body.succededProducts;
					var errorProducts = res.body.errorProducts;
					console.log("context path: "+app.config.contextPath);
					cartBase.hideCartSizeWidget();
					if (res.status == 200) {
						if(null != errorProducts && errorProducts != undefined && errorProducts.length > 0){
							cartBase._modals.warning.showAddedToCartMessage(succededProducts, errorProducts);
						}else{
							cartBase._modals.success.showAddedToCartMessage(succededProducts);
						}
//						window.location.href=app.config.contextPath+"/order-checkout";
						var date = new Date();
						date.setTime(date.getTime() + (30 * 1000));
						$.cookie("convertQuoteToOrder", false,{ expires: date ,path: '/'});
						app.core.handlers.onGoTo(app.config.contextPath+"/order-checkout");
						return;
					}

					if (res.status == 530 || res.status == 220) {
						cartBase._modals.warning.showAddedToCartMessage(succededProducts, errorProducts);
						return;
					}
				} else {
					console.log(res);
					cartBase._modals.warning.show(res.message);
				}
			} else {
				console.log(res);
			}
		};
		
		cartBase.postAdditionRoutine = function (res) {
			if (res) {
				if (res.status == 200 || res.status == 530 || res.status == 220) {
					cartBase._stash.cart.size = res.body.cartSize;
					cartBase.updateWidget();

					var succededProducts = res.body.succededProducts;
					var errorProducts = res.body.errorProducts;
					
					if (res.status == 200) {
						cartBase._modals.success.showAddedToCartMessage(succededProducts);
					}

					if (res.status == 530 || res.status == 220) {
						//cartBase._modals.warning.showAddedToCartMessage(succededProducts, errorProducts);
				        cartBase._modals.errorPopup.showAddedToCartMessage(succededProducts, errorProducts);
					}
				} else {
					console.log(res);
					cartBase._modals.warning.show(res.message);
				}
			} else {
				// global response error
				// cartBase.handleErrors()
				console.log(res);
			}
		};

		cartBase.updateWidget = function () {
			var cartSize = cartBase._stash.cart.size;
			cartBase.elements.cartSizeWidget.text(cartSize);
		};

		cartBase.showCartSizeWidget = function () {
			cartBase.updateWidget();
			cartBase.elements.cartSizeWidgetContainer.removeClass("hide");
		};
		
		cartBase.hideCartSizeWidget = function () {
			cartBase.updateWidget();
			cartBase.elements.cartSizeWidgetContainer.addClass("hide");
		};
		
		cartBase.nullifyCartSize = function () {
			cartBase._stash.cart.size = 0;
			cartBase.updateWidget();
		};

		cartBase.resetCart = function () {
			return cartBase._api.cart.detachOrderFromCart().then(function (res) {
				if (res && res.status == 200) {
					cartBase.nullifyCartSize();
					return true;
				} else {
					cartBase._modals.warning.show(cartBase._messages.serverError);
					console.log(res);
				}
			});
		};

		cartBase.handlers = {

		};

		cartBase.getCartItems = function () {
			return cartBase._api.cart.get().then(function (res) {
				if (res && res.status == 200) {
					cartBase.cartData = res.body.cartData;
					cartBase.cartKits = res.body.productAccessoriesRelation;
					cartBase.minimumOrderAmount = res.body.minimumOrderAmount;
					cartBase._stash.cart.size = cartBase.cartData.totalItems;
					cartBase.updateWidget();
					return res;
				} else {
					console.log(res);
					cartBase._modals.warning.show(cartBase._messages.cartItemsError);
				}
			});
		};

		cartBase.removeItems = function (entriesIdxsArrayToDelete) {
			return cartBase._api.cart.remove(entriesIdxsArrayToDelete).then(function (res) {
				if (res && res.status == 200) {
					cartBase._stash.cart.size = res.body.cartData.totalItems;
					cartBase.updateWidget();
					return res;
				} else {
					console.log(res);
					cartBase._modals.warning.show(cartBase._messages.cartRemoveItemsError);
				}
			});
		};

		cartBase.removeItemByPk = function (pks) {
			return cartBase._api.cart.removeByPk(pks).then(function (res) {
				if (res && res.status == 200) {
					cartBase._stash.cart.size = res.body.cartSize;
					cartBase.updateWidget();
					return res;
				} else {
					console.log(res);
					cartBase._modals.warning.show(cartBase._messages.cartRemoveItemsError);
				}
			});
		};


		cartBase.addItems = function (cartDataArray) {

			var cartData = {
				products: cartDataArray,
				b2bUnitId: cartBase._b2bUnit.currentUnit.uid
			};

			cartBase._api.cart.addProducts(cartData).then(function (res) {
				cartBase.postAdditionRoutine(res);
			});
		};

		cartBase.addOrderOrQuoteByCode = function (orderCode) {
			cartBase._api.cart.addOrder(orderCode).then(function (res) {
				// rewrite using status code handler
				cartBase.postAdditionRoutine(res);
			});
		};

		cartBase.convertQuoteToOrder = function (quoteCode) {
			cartBase._api.cart.convertQuote(quoteCode).then(function (res) {
				// rewrite using status code handler
				
				/*cartBase._api.orderCheckout.initCheckout().then(function (res){
					cartBase.postAdditionRoutine(res);
				});*/
				cartBase.postAdditionFromQuote(res);
			});
		};
		
		cartBase.init = function () {

			cartBase._bindings();

			cartBase._events.registerHandler("orderCreated", cartBase.name, cartBase.nullifyCartSize);
			cartBase._events.registerHandler("quoteCreated", cartBase.name, cartBase.nullifyCartSize);
		};



		return cartBase;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});
